import script from "./VitaShiftInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaShiftInfo.vue?vue&type=script&setup=true&lang=ts"

import "./VitaShiftInfo.vue?vue&type=style&index=0&id=7f8261b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8261b2"]])

export default __exports__